/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/function-component-definition */
import React from "react";
import CustomSnackBar from "../components/CustomSnackBar";

interface SnackBarState {
  toastMessage: (message: string) => void;
  closeSnackBar: () => void;
}

export const CustomSnackBarContext = React.createContext({} as SnackBarState);

export const CustomSnackBarProvider = (props: React.PropsWithChildren) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");

  const closeSnackBar = () => setOpen(false);

  const toastMessage = (newMessage: string) => {
    setMessage(newMessage);

    if (!open) {
      setOpen(true);
    }
  };

  const value = { toastMessage, closeSnackBar };

  return (
    <CustomSnackBarContext.Provider value={value}>
      <CustomSnackBar open={open} message={message} handleOnClose={closeSnackBar} />
      {props.children}
    </CustomSnackBarContext.Provider>
  );
};
